import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
interface Bonus {
  num: number;
  icon: string;
  title: string;
  desc: string;
  cover: string;
  spine: string;
}
export function BonusSection() {
  const bonuses: Bonus[] = [{
    num: 1,
    icon: '💌',
    title: 'El Diario de las 48 Horas',
    desc: 'El protocolo emocional para no romperte cuando él desaparece, no responde o te activa la ansiedad de golpe.',
    cover: '#5b2a86',
    spine: '#3f1d5e'
  }, {
    num: 2,
    icon: '🔮',
    title: 'El Oráculo del Radar de Disponibilidad',
    desc: 'La guía para detectar rápido si estás frente a un hombre disponible, tibio o emocionalmente inaccesible.',
    cover: '#3a2a6e',
    spine: '#271c4d'
  }, {
    num: 3,
    icon: '📱',
    title: 'Guía de Textos Magnéticos',
    desc: 'Qué decir, qué no decir y cómo no regalar tu energía por WhatsApp en los primeros intercambios.',
    cover: '#8a2d5a',
    spine: '#641f41'
  }, {
    num: 4,
    icon: '🌹',
    title: 'Ritual de los 7 Días para Encender a Venus',
    desc: 'Activación práctica de sensualidad, valor propio, recepción y abundancia amorosa.',
    cover: '#a23b4e',
    spine: '#7a2937'
  }, {
    num: 5,
    icon: '🧹',
    title: 'Detox de Ex-Parejas',
    desc: 'Manual de contacto cero real para resetear tu sistema nervioso y cortar la fijación emocional de una vez.',
    cover: '#2d4a6e',
    spine: '#1e344d'
  }, {
    num: 6,
    icon: '🧠',
    title: '101 Afirmaciones en Estado Theta',
    desc: 'Para romper el techo de cristal de tu valor propio y dejar de sentirte menos en el amor.',
    cover: '#6e4a86',
    spine: '#4f335e'
  }];
  return <section className="py-20 px-4 bg-mystic-800 relative" data-id="element-19">
      <div className="max-w-6xl mx-auto" data-id="element-20">
        <div className="text-center mb-16" data-id="element-21">
          <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-gold-500 to-gold-600 text-mystic-900 font-bold text-lg mb-8 shadow-[0_0_30px_rgba(212,175,55,0.3)]" data-id="element-22">
            <Gift className="w-5 h-5" data-id="element-23" />
            🎁 GRATIS POR EL DÍA DE HOY
          </motion.div>

          <h2 className="text-4xl md:text-5xl font-serif font-bold text-white mb-4" data-id="element-24">
            + 6 Regalos Estratégicos
          </h2>
          <p className="text-xl text-lilac-300 font-medium" data-id="element-25">
            Incluidos sin costo extra · Valor real del pack
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-26">
          {bonuses.map((bonus, i) => <motion.div key={bonus.num} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i % 3 * 0.1
        }} className="bg-mystic-900 rounded-2xl border border-mystic-700 hover:border-gold-500/50 transition-all group shadow-xl p-8 flex flex-col items-center text-center" data-id="element-27">
              {/* Book cover mockup */}
              <div className="mb-6 group-hover:-translate-y-1 transition-transform duration-300" data-id="element-28">
                <div className="relative w-44 h-60 rounded-r-lg rounded-l-sm shadow-[0_20px_40px_-10px_rgba(0,0,0,0.6)] flex flex-col justify-between p-5 text-left overflow-hidden" style={{
              backgroundColor: bonus.cover
            }} data-id="element-29">
                  {/* Spine */}
                  <div className="absolute left-0 top-0 bottom-0 w-3" style={{
                backgroundColor: bonus.spine
              }} data-id="element-30" />
                  {/* Subtle sheen */}
                  <div className="absolute inset-0 bg-gradient-to-br from-white/10 via-transparent to-black/20 pointer-events-none" data-id="element-31" />

                  <div className="relative z-10 pl-2" data-id="element-32">
                    <div className="text-3xl mb-3 drop-shadow" data-id="element-33">
                      {bonus.icon}
                    </div>
                  </div>

                  <div className="relative z-10 pl-2" data-id="element-34">
                    <div className="text-white font-serif font-bold text-2xl leading-none mb-3" data-id="element-35">
                      Bonus {bonus.num}
                    </div>
                    <div className="h-px w-full bg-white/30 mb-3" data-id="element-36" />
                    <div className="text-white/70 text-[10px] font-bold tracking-[0.2em] uppercase" data-id="element-37">
                      ASTRO SER™
                    </div>
                  </div>
                </div>
              </div>

              {/* GRATIS pill */}
              <span className="inline-block px-4 py-1 rounded-full bg-green-500/15 text-green-400 text-xs font-bold tracking-widest uppercase mb-4" data-id="element-38">
                GRATIS
              </span>

              <h3 className="text-xl font-serif font-bold text-white mb-3 leading-tight" data-id="element-39">
                {bonus.icon} Bonus {bonus.num} — {bonus.title}
              </h3>
              <p className="text-slate-300 text-sm leading-relaxed" data-id="element-40">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}